module.exports = __webpack_public_path__ + "img/family.6762bcb3.png";